<template>
  <div class="mian_view" id="pdfDom">
    <div class="mian_table">
      <div class="hader">
        <h3>练习情况</h3>
        <el-button type="primary" @click="toReturn">返回</el-button>
      </div>
      <div class="download_page" v-if="$refs.son">
        <!-- 下载按钮 -->
        <el-button type="primary" @click="clickPdf">下载页面</el-button>
      </div>
      <div class="table_box">
        <el-table :data="situationData" border style="width: 100%">
          <el-table-column
            v-for="(item, index) in situationForm"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="mian_table">
      <h3>客观题作答情况</h3>
      <div class="table_box_tow">
        <el-table :data="kgtAnswer" border style="width: 100%">
          <el-table-column
            v-for="(item, index) in kgtAnswerTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="mian_table">
      <h3>科室作答情况</h3>
      <div class="table_box">
        <el-table :data="ksAnswer" border style="width: 100%">
          <el-table-column
            v-for="(item, index) in ksAnswerForm"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <Son ref="son" />
  </div>
</template>

<script>
import { situationArr, kgtAnswerArr, ksAnswerArr } from "@/state/practiceModel";
import Son from "./Son.vue";
import loginvuex from "@/store/index";
import $examApi from "@/api/examApi.js";
import { saveAs } from "file-saver";
import * as JSZip from "jszip";

export default {
  data() {
    return {
      situationData: [], // 练习情况数据
      situationForm: [], // 练习情况表格渲染
      kgtAnswer: [
        // {
        //   correct: "正确率"
        // }
      ], // 客观题作答情况数据
      kgtAnswerTable: [], // 客观题作答情况表格渲染
      ksAnswer: [
        {
          correct: "正确率",
        },
      ], // 科室作答情况数据
      fileArr: [],
      ksAnswerForm: [], //  科室作答情况表格渲染
    };
  },
  props: ["cutcoms"],
  methods: {
    // 初始化
    Initialize() {
      this.situationForm = situationArr;
      // this.kgtAnswerTable = kgtAnswerArr;
      this.ksAnswerForm = ksAnswerArr;
    },
    //返回
    toReturn() {
      if (this.$route.query.trainId) {
        // 培训过来的
        this.$router.push({
          path: this.$route.query.toUrl,
          query: {
            trainId: this.$route.query.trainId,
            state:'xxqk',
            toUrl: this.$route.query.toUrl
          },
        });
      } else {
        this.cutcoms(0);
      }
      this.$destroy();
    },
    // 获取列表数据
    async getDatalist() {
      let parameter = {
        examID: this.$parent.currentLine.ExamID, // 试卷ID
        userID: JSON.parse(loginvuex.state.userlist).userID, // 用户ID
        guid: JSON.parse(loginvuex.state.userlist).guid, // token
      };
      const data = await $examApi.practiceData(parameter);
      if (data.status == 200) {
        this.situationData.push(data.data.Data.info);
        this.$set(
          this.situationData[0],
          "IsPublish",
          this.$parent.currentLine.IsPublish
        );
        let newKgtArr = data.data.Data.testStyleInfo.map((item) => {
          return { label: item.Style, prop: `rightRate${item.Style}` };
        });
        let oldArr = [
          {
            prop: "correct",
            label: "题型",
            width: "160",
          },
        ];
        this.kgtAnswerTable = oldArr.concat(newKgtArr);
        let rateArr = data.data.Data.testStyleInfo.map((item) => {
          if (item.rightRate == 0.0) {
            item.rightRate = 0; //会出现0.0的情况，默认修改为0
          }
          let obj = {};
          this.$set(obj, `rightRate${item.Style}`, item.rightRate + "%"); // 增加一个唯一key值
          return obj;
        });
        let kgtArr = rateArr.reduce((result, current) => {
          // 将数组里的对象全部合并成一个对象
          for (var key in current) {
            if (current.hasOwnProperty(key)) {
              result[key] = current[key];
            }
          }
          return result;
        });
        this.kgtAnswer[0] = kgtArr;
        this.kgtAnswer[0].correct = "正确率";
        // department
        this.ksAnswer = data.data.Data.department; // 处理科室作情况
        this.ksAnswer.map((item) => {
          this.$set(item, "rightRate1", item.rightRate + "%");
          this.$set(item, "haveRate1", item.haveRate + "%");
          return item;
        });
      }
    },
    // 导出 pdf
    async clickPdf() {
      // this.rolling = false; // 将数据全部展开
      // 导出规则是当前是展示多少条就导出多少条
      // await this.$refs.son.changPaging(this.$refs.Ranking.paging);
      // await this.$refs.Department.changPaging(this.$refs.Department.paging);
      if (this.$refs.son.getData.length > 0) {
        // 当表格有数据的时候导出表格
        this.toGetPdf(1, 0); // 获取pdf地址
        // this.$message({
        //   message: "恭喜你，成绩报告已导出",
        //   type: "success"
        // });
      } else {
        this.toGetPdf(0); // PDF生成直接导出
        this.$message({
          message: "警告，当前表格无数据，只导出PDF成绩报告",
          type: "warning",
        });
      }
      // this.rolling = true; // 收起来
    },
    // PDF下载
    toGetPdf(val = false, download = true) {
      /**
     * val 决定走不走上传接口，默认为不上传给后端
     * download 默认是下载
     * /
      /* */

      this.$nextTick(() => {
        setTimeout(() => {
          window.scrollTo(0, 0); //这行代码很重要，它让页面的滚动条跳到了最上方如果点击打印按钮的时候,滚动条没有在最上方,打印内容会是不完整的,体验也会差
          let title = "练习成绩报告单";
          this.getPdf(title, download) //download：false为不下载，这里调用了刚刚引用的全局函数，.then得到的值是base64位的pdf文件
            .then((res) => {
              if (val) {
                let newArr = [
                  {
                    prop: "practiceTime",
                    label: "作答次数",
                    width: "300",
                  },
                  {
                    prop: "spendTime",
                    label: "最近答题用时(分钟)",
                    width: "300",
                  },
                  {
                    prop: "doneNum1",
                    label: "最近作答情况(已答/总题数)",
                    width: "300",
                  },
                  {
                    prop: "rightRate1",
                    label: "最近正确率",
                    width: "300",
                  },
                  {
                    prop: "score",
                    label: "最近练习成绩",
                    width: "300",
                  },
                  {
                    prop: "stateHave",
                    label: "练习状态",
                    width: "300",
                  },
                  {
                    prop: "submitTime",
                    label: "完成时间",
                    width: "300",
                  },
                ];
                // newArr = newArr.concat(this.$refs.son.formColumns);
                const arr = this.$refs.son.formColumns.concat(newArr)
                let a = this.$downloadExcel(
                  this.$refs.son.getData,
                  arr,
                  "url"
                );
                let obj1 = {
                  name: "个体练习情况",
                  file: a,
                  suffix: ".xls",
                };
                this.fileArr = []; // 重置
                this.fileArr.push(obj1); // 获取表格地址
                let obj = {
                  name: "练习成绩报告单",
                  file: res,
                  suffix: ".pdf",
                };
                this.fileArr.push(obj);
                this.download(this.fileArr); // 执行打包压缩
                // this.UploadPdf(res);
              } else {
                console.log("不上传");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }, 1000);
      });
    },
    // 压缩包
    download(arr) {
      const zip = new JSZip(); // 实例化zip
      const img = zip.folder("练习成绩报告单"); // zip包内的文件夹名字
      const fileReader = new FileReader();
      const dataList = arr.map((item) => {
        return new Promise(async (reslove, reject) => {
          let basePic = "";
          if (Object.prototype.toString.call(item.file) === "[object Blob]") {
            fileReader.onload = (e) => {
              basePic = e.target.result.replace(
                /^data:application\/(.*?);base64,/,
                ""
              );
              // 将文件加入到zip包内
              reslove({
                name: "练习成绩报告",
                file: basePic,
                suffix: ".xls",
              });
            };
            fileReader.readAsDataURL(item.file);
          } else {
            basePic = item.file.replace(/^data:application\/(.*?);base64,/, "");
            reslove({
              name: "练习成绩报告",
              file: basePic,
              suffix: ".pdf",
            });
          }
        });
      });

      Promise.all(dataList).then((res) => {
        // 拿到所有处理好的数据去下载
        res.forEach((e) => {
          img.file(e.name + e.suffix, e.file, { base64: true }); // 将  文件加入到zip包内
        });
        zip
          .generateAsync({
            type: "blob",
            compression: "DEFLATE", // STORE：默认不压缩 DEFLATE：需要压缩
            compressionOptions: {
              level: 9, // 压缩等级1~9    1压缩速度最快，9最优压缩方式
              // [使用一张图片测试之后1和9压缩的力度不大，相差100字节左右]
            },
          }) // zip下载
          .then(function (content) {
            // see FileSaver.js
            saveAs(content, "练习成绩报告.zip"); // zip下载后的名字
          });
      });

      //   执行下载方法
    },
  },
  components: {
    Son,
  },
  created() {
    this.Initialize();
    this.getDatalist();
  },
};
</script>

<style lang="scss" scoped>
.mian_view {
  width: 100%;
  min-height: 780px;
  padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
  .mian_table {
    .hader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-button {
        width: 92px;
        margin-right: 24px;
      }
    }
    h3 {
      letter-spacing: 2px;
    }
    .table_box {
      width: 760px;
      margin: 42px 160px;
    }
  }
  .table_box_tow {
    width: 920px;
    margin: 42px 160px;
  }
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
  letter-spacing: 1px;
  color: #2c3e50;
  font-size: 14px;
}
::v-deep .el-table td > .cell {
  align-items: center !important;
  text-align: center;
  letter-spacing: 2px;
  color: #2c3e50;
}
.download_page {
  display: flex;
  padding: 22px;
  justify-content: flex-end;
}
</style>
